module.exports = __webpack_public_path__ + "img/collectMonitoringIcon.8268fad1.png";